import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { SEOWrapper } from "@/components/SEOWrapper";
import { CTAFinal } from "@/components/home/CTAFinal";
import { usePageSeo } from "@/hooks/usePageSeo";

import {
  CaseStudiesHubHero,
  CaseStudiesHubSummary,
  CaseStudiesGrid,
  CaseStudiesHubFAQ,
} from "@/components/case-studies";

const CaseStudiesHubPage = () => {
  const { language, url, esUrl, enUrl, onLanguageChange } = usePageSeo();

  const meta = {
    es: {
      title: "Casos de Éxito SEO y Google Ads | Resultados Reales - Luis ROC",
      description: "Casos de éxito reales en SEO técnico, SEO local y Google Ads para empresas B2B. Proceso documentado, problemas resueltos y resultados observables. Houston, Texas.",
      keywords: [
        "casos de éxito SEO",
        "resultados SEO empresas",
        "casos Google Ads",
        "SEO técnico resultados",
        "SEO B2B casos",
        "consultor SEO Houston casos",
      ],
    },
    en: {
      title: "SEO and Google Ads Case Studies | Real Results - Luis ROC",
      description: "Real success cases in technical SEO, local SEO and Google Ads for B2B companies. Documented process, solved problems and observable results. Houston, Texas.",
      keywords: [
        "SEO case studies",
        "SEO business results",
        "Google Ads cases",
        "technical SEO results",
        "B2B SEO cases",
        "Houston SEO consultant cases",
      ],
    },
  };

  const currentMeta = meta[language];

  return (
    <SEOWrapper
      title={currentMeta.title}
      description={currentMeta.description}
      keywords={currentMeta.keywords}
      url={url}
      esUrl={esUrl}
      enUrl={enUrl}
      language={language}
      pageType="website"
      summary={
        language === "es"
          ? "Casos de éxito documentados en SEO técnico, SEO local y Google Ads para empresas B2B. Luis ROC, consultor SEO en Houston, Texas."
          : "Documented case studies in technical SEO, local SEO and Google Ads for B2B companies. Luis ROC, Houston SEO consultant."
      }
      keyPoints={
        language === "es"
          ? [
              "Casos de éxito SEO reales",
              "Empresas B2B atendidas",
              "Proceso documentado",
              "Resultados observables",
              "Houston, Texas",
            ]
          : [
              "Real SEO case studies",
              "B2B companies served",
              "Documented process",
              "Observable results",
              "Houston, Texas",
            ]
      }
    >
      <div className="min-h-screen" style={{ background: "var(--v3-mineral)" }}>
        <Header language={language} onLanguageChange={onLanguageChange} />

        <main>
          <CaseStudiesHubHero language={language} />
          <CaseStudiesGrid language={language} />
          <CaseStudiesHubSummary language={language} />
          <CaseStudiesHubFAQ language={language} />
          <CTAFinal language={language} />
        </main>

        <Footer language={language} />
        <WhatsAppFloat />
      </div>
    </SEOWrapper>
  );
};

export default CaseStudiesHubPage;
